import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
// import { ValuationService } from 'src/app/shared/services/valuations.service';
import { ValuationRequestService } from '../../../shared/services/valuations-request.service';

@Component({
  selector: 'app-view-single-valuation-request',
  templateUrl: './view-single-valuation-request.component.html',
  styleUrls: ['./view-single-valuation-request.component.css']
})
export class ViewSingleValuationRequestComponent implements OnInit {
  isLoading: boolean = false;
  editValuationRequestForm: FormGroup;
  name: string | undefined;
  valuationId: any;
  propertyId: any;
  // private fb: FormBuilder
  valuations: any = [];
  constructor(
    private router: Router, 
    private fb: FormBuilder, 
    private route: ActivatedRoute,
    private ValuationRequestService: ValuationRequestService,
    // private ValuationsService: ValuationService
    ) {
    this.editValuationRequestForm = this.fb.group({
      description: [''],
      propertyName: [''],
      agencyName: [''],
      status: [''],
      creationDate: ['']
    })
  }

  recievedValuationRequest: any;

  customStylesValidated = false;

  ngOnInit(): void {
    console.log("router: ", this.router);
    this.route.queryParams.subscribe(params => {
        
        this.recievedValuationRequest = params;
        console.log("recievedValuationRequest: ", this.recievedValuationRequest);
        this.valuationId = this.recievedValuationRequest.valuationRequestId;
        this.propertyId = this.recievedValuationRequest.propertyId;
        console.log('this.recievedValuationRequest.category');
      }
    );
        
    const formValues = {
      description: [this.recievedValuationRequest.description ? this.recievedValuationRequest.description : ''],
      propertyName: [this.recievedValuationRequest.propertyName ? this.recievedValuationRequest.propertyName : ''],
      agencyName: [this.recievedValuationRequest.agencyName ? this.recievedValuationRequest.agencyName : ''],
      status: [this.recievedValuationRequest.status ? this.recievedValuationRequest.status : ''],
      creationDate: [this.recievedValuationRequest.creationDate ? this.recievedValuationRequest.creationDate : '']
    };

    this.editValuationRequestForm = this.fb.group(formValues);  //populate form with current values
    // this.getValuationByPropertyID();
  }

  onSubmitEditForm() {
    console.log(this.valuationId);
    console.log(this.propertyId);
    console.log('here');
    console.log('here');
    // console.log(this.propertyId);
    this.customStylesValidated = true;

    const object = {
      // valuationRequestId: this.valuationId,
      propertyId: this.propertyId,
      creationDate: this.editValuationRequestForm.value.creationDate,
      description: this.editValuationRequestForm.value.description,
      propertyName: this.editValuationRequestForm.value.propertyName,
      status: this.editValuationRequestForm.value.status,
      agencyName: this.editValuationRequestForm.value.agencyName
    }
    
    this.ValuationRequestService.editValuationRequests(object,this.valuationId).subscribe((data) => {
      console.log(data);
            setTimeout(() => {
              alert('Valuation requests details updated!');
              this.router.navigate(
                ['/valuation-requests/view']);
            }, 500);
    }, err => {
            console.log(err);
            this.router.navigate(
              ['/valuation-requests/view']);
    });
    console.log("Form submitted", this.editValuationRequestForm?.value);
  }

  onReset1() {

  }

  onEditValuationRequest() {
    console.log("Edit: ", this.recievedValuationRequest);
    const queryParams: Params = this.recievedValuationRequest;

    this.router.navigate(
      ['/private-space/edit-valuation-request'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  OpenValuation(valuation: any) {
    console.log("Open: ", valuation);
    const queryParams: Params = valuation;

    this.router.navigate(
      ['/valuations/view-single'],
      {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge', // remove to replace all query params by provided
      });
  }

  // getValuationByPropertyID() {
  //   this.isLoading = true;
    
  //   this.ValuationsService.getAllValuationsByStatus("NEW").subscribe((data) =>{
  //     this.isLoading = false;
  //     console.log("data", data);
  //     this.valuations = data.filter((val: { propertyId: string; }) => val.propertyId === this.recievedValuationRequest.propertyId);
  //     console.log("data filtered", this.valuations);
  //     console.log("data filtered", this.recievedValuationRequest.propertyId);

  //   }, (error) =>{
  //     console.log("Error", error);
  //     this.isLoading = false;
      
  //   });
  // }

}
